import styled from '@emotion/styled';
import { BLACK_COLOR_RGBA, WHITE_COLOR } from '@operoute/ui';

export const Paper = styled.div`
  background-color: ${WHITE_COLOR};
  border-radius: 5px;
  box-shadow: 0 4px 8px 1px ${BLACK_COLOR_RGBA(0.15)};
  box-sizing: border-box;
`;
